import { tagsSlice } from "./tagsSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as fields from "../../pages/TaskData/tabs/tags/edit/constants";
import { Dispatch } from "redux";
import { get } from "../../../../../api/requester";
import { constructInitialFilters } from "../../../../components/common/filters/utils";
import i18next from "i18next";

export const QPARAMS_CHANGED = "Tags/QParamsChanged";
const { actions } = tagsSlice;
const moduleUrl = '/api/masterdata/tags'

export const setValidationErrors = actions.setValidationErrors;


export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );



export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);

export const setFilter = (filters: any[]) => actions.setFilter(filters);
export const getFilters = () => async (dispatch:Dispatch) => {
  try {
    const taskTypes:any[] = await get("api/activity/taskTypes/complexSearch");

    dispatch(setFilter(
        constructInitialFilters([
          ...(taskTypes || []).map((t) => ({
            ...t,
            title: i18next.t(`TaskTypes.${t.value}`)
          })),
        ])
    ) as any);
    
  } catch (errors) {
    // const message = getErrorMessage(errors, "Error occurred!");
    // dispatch(actions.catchError({ message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
};
